import { NgModule } from '@angular/core';
import { ProductStatusPipe } from './product-status/product-status.pipe';
import { DateToIntervalPipe } from './date-to-interval/date-to-interval.pipe';
import { QualityPipe } from './product-status/quality.pipe';
import { AuditActionPipe } from './audit-action/audit-action.pipe';
import { ApplicationNamePipe } from './application-name/user-group.pipe';
import { AppNamePipe } from './AppId-To-Name/app-name.pipe';

let pipesArray = [
  ProductStatusPipe,
  DateToIntervalPipe,
  QualityPipe,
  AuditActionPipe,
  ApplicationNamePipe,
  AppNamePipe
]

@NgModule({
  declarations: pipesArray,
  imports: [],
  providers: [],
  exports: pipesArray
})
export class PipeModule { }
